<template>
  <AppLayout>
    <template #default>
      <h1> {{ $t('forgottenPasswordPage.title') }} </h1>
      <form @submit.prevent="handleSubmit">
        <FormInput
          id="forgotten-password-email"
          :label="$t('forgottenPasswordPage.label')"
          required
          v-model="form.email"
        >
          <template #error v-if="emailNotFound"> {{ $t('forgottenPasswordPage.mail-unknown') }} </template>
        </FormInput>

        <div class="submit">
          <ButtonGreen :busy="isSubmitting" :disabled="!canBeSubmitted" :icon="$icons.continue" type="submit">
            {{ $t('forgottenPasswordPage.continue') }}
          </ButtonGreen>
        </div>
      </form>
    </template>
  </AppLayout>
</template>

<script>
  import ButtonGreen from '@/components/ButtonGreen.vue';
  import FormInput from '@/components/Form/FormInput.vue';
  import AppLayout from '@/components/AppLayout.vue';
  import { email, required } from '@byscripts/vuelidate/lib/validators';
  import Auth from '../../api/auth.js';

  export default {
    name: 'ForgottenPasswordPage',
    components: { AppLayout, FormInput, ButtonGreen },
    data() {
      return {
        form: {
          email: null,
        },
        isSubmitting: false,
        emailNotFound: false,
      };
    },
    validations: {
      form: {
        email: {
          required,
          email,
        },
      },
    },
    computed: {
      canBeSubmitted() {
        return !this.$v.$invalid;
      },
    },
    methods: {
      async handleSubmit() {
        try {
          this.isSubmitting = true;
          this.emailNotFound = false;

          this.$v.$touch();

          if (this.$v.$invalid) {
            return this.$addError(this.$t('forgottenPasswordPage.form-error'));
          }

          await Auth.recoverPassword(this.form.email);

          await this.$router.push({ name: 'forgotten-password-confirm' });
        } catch (e) {
          await this.$addError(this.$t('forgottenPasswordPage.error'));
        } finally {
          this.isSubmitting = false;
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .form-input {
    margin-bottom: 3rem;
  }

  .submit {
    margin-top: 15rem;
    text-align: right;
  }
</style>
